module.exports = __webpack_public_path__ + "static/media/GMA-S2100SK-7AER_OR14_beautyshot2.175ff6f8.jpg";